import { httpCreate } from './http';

const http = httpCreate('/shop/api/goodsCategory/');

export const goodsCategory = {
	getCategoryList(userId) {
		return http.get(`list/${userId}`);
	},
	/**
	 * 添加商品查询类目下拉列表数据
	 * @param {number} activityId 直播间id
	 */
	getActivityCategoryList(activityId) {
		return http.get(`list/activity/${activityId}`);
	},
};
